export const ReservationRoutes = {
    Home: 'reservation',
    Reservation: 'reservation-data',
    Finished: 'reservation-finished'
};
